import { styled } from '@material-ui/core/styles';

export const ActionsRow = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1, 0),
  justifyContent: 'flex-end'
}));

export const MenuContainer = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(2)
}));
